// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"177":"0e3916a6","448":"55fafd0e"}[chunkId] + ".chunk.css";
};